var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Auth, Layout, Dependencies } from '~/core/decorator';
import DataBox from '~/components/common/data-box.vue';
import DataForm from '~/components/common/data-form.vue';
import { PageService } from '~/utils/page.service';
import NumberRange from '~/components/common/number-range.vue';
import { MENU_CHANNEL } from "~/config/enum.config";
import { State, namespace } from "vuex-class";
import { CarManageService } from "~/services/domain-service/car-manage.service";
import WarehousingAudit from '~/components/car-management/warehousing-audit.vue';
var CollectionExecutionModule = namespace("collection-execution");
var WarehouseManagementApproal = /** @class */ (function (_super) {
    __extends(WarehouseManagementApproal, _super);
    function WarehouseManagementApproal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.dataForm = {
            batchNumber: "",
            mobileNo: "",
            personalName: "",
            overdueAmount: { min: "", max: "" },
            caseNumber: '',
            principalId: '',
            partnerName: '',
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            plateNum: '',
            idCard: '',
            loanDate: [],
            applyTime: [],
            applyRealName: '',
            warehouseCarStatus: '',
            garageName: '',
            userName: ''
        };
        _this.dailog = {
            warehousingShow: false
        };
        _this.rowData = {};
        return _this;
    }
    Object.defineProperty(WarehouseManagementApproal.prototype, "titleName", {
        get: function () {
            return this.rowData.warehouseCarStatus === 'IN_WAREHOUSE_WAIT_APPROVED' ? '入库审核' : this.rowData.warehouseCarStatus === 'OUT_WAREHOUSE_WAIT_APPROVED' ? '出库审核' : '临时入库登记';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WarehouseManagementApproal.prototype, "userId", {
        get: function () {
            return this.userData.id;
        },
        enumerable: false,
        configurable: true
    });
    WarehouseManagementApproal.prototype.created = function () {
        this.refreshData();
    };
    WarehouseManagementApproal.prototype.params = function () {
        var params = __assign({}, this.dataForm);
        params.overdueAmountMax = this.dataForm.overdueAmount.max;
        params.overdueAmountMin = this.dataForm.overdueAmount.min;
        params.loanDateMin = this.$filter.dateRanageFormat(this.dataForm.loanDate).start;
        params.loanDateMax = this.$filter.dateRanageFormat(this.dataForm.loanDate).end;
        params.applyTimeMin = this.dataForm.applyTime.length ? this.$filter.dateTimeFormat(this.dataForm.applyTime[0]) : '';
        params.applyTimeMax = this.dataForm.applyTime.length ? this.$filter.dateTimeFormat(this.dataForm.applyTime[1]) : '';
        delete params.overdueAmount;
        delete params.loanDate;
        delete params.applyTime;
        return params;
    };
    WarehouseManagementApproal.prototype.refreshData = function () {
        var _this = this;
        this.carManageService.getAllWarehouseApproval(this.params(), this.pageService).subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    /**
     * 导出库管审批
     */
    WarehouseManagementApproal.prototype.onClickExport = function () {
        var _this = this;
        if (!this.dataSet.length)
            return this.$message.warning('暂无数据无需导出！');
        this.carManageService.warehouseApprovalExport(this.refreshData()).subscribe(function (data) {
            _this.$common.downloadFile(data.url);
        });
    };
    WarehouseManagementApproal.prototype.onClickGarage = function (row) {
        this.rowData = row;
        this.dailog.warehousingShow = true;
    };
    /**
     * 进入查看执行页
     */
    WarehouseManagementApproal.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Car_warehouse_approval,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    WarehouseManagementApproal.prototype.handleResetForm = function () {
        this.dataForm.overdueAmount = { min: "", max: "" };
    };
    __decorate([
        Dependencies(PageService)
    ], WarehouseManagementApproal.prototype, "pageService", void 0);
    __decorate([
        State
    ], WarehouseManagementApproal.prototype, "principalList", void 0);
    __decorate([
        Dependencies(CarManageService)
    ], WarehouseManagementApproal.prototype, "carManageService", void 0);
    __decorate([
        State
    ], WarehouseManagementApproal.prototype, "userData", void 0);
    WarehouseManagementApproal = __decorate([
        Auth(1534),
        Layout('workspace'),
        Component({
            components: {
                DataBox: DataBox,
                DataForm: DataForm,
                NumberRange: NumberRange,
                WarehousingAudit: WarehousingAudit
            }
        })
    ], WarehouseManagementApproal);
    return WarehouseManagementApproal;
}(Vue));
export default WarehouseManagementApproal;
